import { render, staticRenderFns } from "./sendResult.vue?vue&type=template&id=14d2d2b9&scoped=true&"
import script from "./sendResult.vue?vue&type=script&lang=js&"
export * from "./sendResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d2d2b9",
  null
  
)

export default component.exports